<hr *ngIf="currentOrg?.user" class="community-divider" />
<ng-container *ngIf="currentOrg?.user === false">
  <div class="heading-link" [class.analyst-studio]="isAnalystStudio$ | async">
    <span class="mode-nav-header link-title">Definitions</span>
  </div>
</ng-container>
<ul *ngIf="isDatasourcesLoading" class="loading" [class.analyst-studio]="isAnalystStudio$ | async">
  <li></li>
  <ng-container *ngIf="currentOrg?.user === false">
    <li></li>
    <li></li>
  </ng-container>
</ul>
<ul [class.analyst-studio]="isAnalystStudio$ | async">
  <li
    *ngFor="
      let datasource of filteredDatasources
        | slice: 0:(showAllDatasources ? filteredDatasources.length : datasourceLimit)
    "
    data-test="data-source"
  >
    <a
      [modeLegacyRouterLink]="['/home', currentOrg?.username, 'data_sources', datasource.token]"
      modeLegacyRouterLinkActive="selected"
      [target]="target"
    >
      <capra-icon icon="icon-definition"></capra-icon>
      <div class="title">{{ datasource.displayName }}</div>
    </a>
  </li>
</ul>
<a
  *ngIf="datasourceLimit < filteredDatasources.length"
  href="#"
  class="filter-show-link"
  [class.analyst-studio]="isAnalystStudio$ | async"
  (click)="showAllDatasources = !showAllDatasources"
>
  {{ moreText() }}
</a>
